
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/megastory-detail",
      function () {
        return require("private-next-pages/megastory-detail.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/megastory-detail"])
      });
    }
  